// 活跃度闸门配置
// 映射：助手任务 id -> 游戏活跃度接口 info 中的 key
// 当 info[key] === 2 时表示该活跃度任务已完成，执行该任务前应跳过
export const TASK_ACTIVITY_MAP = {
  // 控制器名与活跃度 key 一致
  lottery: "lottery",                     // 福利抽奖 - 登录抽奖
  hitegg: "hitegg",                       // 砸金蛋
  treasure_map: "treasuremap",            // 藏宝图
  jinyindong: "island",                   // 金银洞
  worldboss: "worldboss",                 // 世界Boss
  overseas_trade: "overseastrade",        // 海外贸易
  jianghunxinglu: "tower",                // 将魂星路
  dailyBusiness: "business",              // 每日通商
  shenjiangzhimen: "generaltask",         // 神将之门
  yingxiongwangzuo: "herothrone",         // 英雄王座
  sixiangshengyv: "sanctum",              // 四象圣域
  glory_front: "glory_front",             // 荣耀前线
  black_market: "black_market",           // 银币/黑市
  peace_art: "peace_art",                 // 太平要术
  // 按游戏活跃度描述对应
  tongtian: "freeheaven",                 // 通天塔
  yiqidangqian: "lkkitousen",             // 一骑当千
  baiyidujiang: "white_river",            // 白衣渡江
  baguazhen: "eight_diagram_tactics",     // 八卦阵
  dixiacheng: "underground_city",         // 地下城
}

// 活跃度信息按账号缓存的过期时间
export const ACTIVITY_CACHE_TTL_MS = 5 * 60 * 1000
